import React, { useCallback, useEffect, useState } from "react";
import { Colors } from "../../../utils/colors/colors";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Schema } from "../../../validators/schema/schema";
import { Col, Container, Row } from "react-bootstrap";
import InputComponent from "../../../utils/input/Input";
import ButtonComponent from "../../../utils/button/ButtonComponent";
import styled from "styled-components";
import RadioComponent from "../../../utils/radio-component/RadioComponent";
import SelectComponent from "../../../utils/select-component/SelectComponent";
import DragAndDrop from "../../../utils/drag-and-drop/DragAndDrop";
import { useLocation, useNavigate } from "react-router-dom";
import { useLocationPathName } from "./../../../hooks/useLocationPathname";
import {
  educationalQualification,
  employmentStatus,
  genderData,
  jobRoleData,
  jobSearchStatusData,
  resumeClinicDetailsData,
} from "../../../assets/data/event-rsvp/resumeClinicData";
import { useResumeClinicRSVP } from "../../../hooks/apis/useResumeClinic.api";
import { toast } from "react-toastify";
import { HOME } from "../../../routes/index.routes";
import { transformData } from "../../../utils/helpers/convertSelectToArray";








const ResumeClinicRsvpFormModal = ({ closeModal }) => {
  const [resumeData, setResumeData] = useState();

  const [
    selectedEducationalQualification,
    setSelectedEducationalQualification,
  ] = useState(educationalQualification[0].value);

  const [selectedEmploymentStatus, setSelectedEmploymentStatus] = useState(
    employmentStatus[0].value
  );

  const [selectedJobSearchStatus, setSelectedJobSearchStatus] = useState(
    jobSearchStatusData[0].value
  );
  const [fileName, setFileName] = useState("");
  const [resumeFile, setResumeFile] = useState(null);

  const { primaryColor } = Colors();

  const {
    title,
    eventDates,
    monthOfTheLatestEvent,
    yearOfTheLatestEvent,
  } = resumeClinicDetailsData();

  const {
    handleSubmit,
    formState: { errors },
    control,
    register,
  } = useForm({
    resolver: yupResolver(Schema().resumeClinicRsvpFormSchema),
    mode: "onBlur",
  });

  /**
   * Set the resume file and name from the selected file
   * @param {File[]} file the selected file
   */
  const handleFile = (file) => {
    setResumeFile(file[0]);
    setFileName(file[0]?.name ?? "");
  };

  const { mutate, status, error } = useResumeClinicRSVP(resumeData, resumeFile);

  const location = useLocation();
  const navigate = useNavigate();

  const { result } = useLocationPathName(location, 1);

  const handleRSVP = useCallback(() => {
    mutate();
  }, [mutate]);


  const onSubmit = useCallback(
    async (data) => {
      console.log(data);

      const getCohortType = () => {
        return eventDates.map((date) =>
          date.type === "second-saturday" ? "Cohort A" : "Cohort B"
        )[0];
      };

      const cohortType = getCohortType();

      setResumeData({
        ...data,
        gender: data?.gender,
        positionInterested: transformData(data?.positionInterested),
        employmentStatus: selectedEmploymentStatus,
        phoneNumber: data?.phoneNumber,
        educationalQualification: selectedEducationalQualification,
        activeSeekingOpportunities: selectedJobSearchStatus,
        cohort: cohortType,
      });

      handleRSVP();
    },
    [
      handleRSVP,
      selectedEducationalQualification,
      selectedJobSearchStatus,
      eventDates,
      selectedEmploymentStatus,
    ]
  );


  useEffect(() => {
    status === "error" && toast.error(error?.response?.data?.error);
    status === "error" && toast.error(error?.message);
    status === "error" && console.error(error?.message);

    status === "success" &&
      toast.success("Form successfully submitted.") &&
      !result &&
      closeModal();

    status === "success" &&
      toast.success("Form successfully submitted.") &&
      result &&
      navigate(HOME);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, result]);

  return (
    <>
      <RsvpHeadingWrapper>
        <HeaderTitle>
          Eraconneckt Resume Clinic: {monthOfTheLatestEvent},{" "}
          {yearOfTheLatestEvent}
        </HeaderTitle>

        <Text>{title} </Text>
      </RsvpHeadingWrapper>

      <form onSubmit={handleSubmit(onSubmit)}>
        <Container
          style={{
            margin: "0",
            padding: "0",
            minWidth: "100%",
            marginTop: "20px",
          }}
        >
          <Row
            style={{
              marginBottom: "10px",
            }}
          >
            <Col>
              <InputComponent
                label={"Full Name"}
                placeholder={"Enter your full name"}
                hasLabel={true}
                name={"fullName"}
                errorText={errors?.fullName?.message}
                rest={{ ...register("fullName") }}
                id={"fullName"}
                type={"text"}
                cName={"form-input"}
                style={{
                  width: "100%",
                }}
                control={control}
                defaultValue={""}
              />
            </Col>
          </Row>

          <Row
            style={{
              marginBottom: "10px",
            }}
          >
            <Col>
              <InputComponent
                label={"Email"}
                placeholder={"Enter your email address"}
                hasLabel={true}
                name={"email"}
                errorText={errors?.email?.message}
                rest={{ ...register("email") }}
                id={"email"}
                type={"text"}
                cName={"form-input"}
                style={{
                  width: "100%",
                }}
                control={control}
                defaultValue={""}
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <InputComponent
                label={"Phone Number"}
                placeholder={"Enter your phone number"}
                hasLabel={true}
                name={"phoneNumber"}
                errorText={errors?.phoneNumber?.message}
                rest={{ ...register("phoneNumber") }}
                id={"phoneNumber"}
                type={"phone"}
                cName={"form-input"}
                style={{
                  width: "100%",
                }}
                control={control}
                defaultValue={""}
              />
            </Col>
          </Row>
          <Row
            style={{
              marginBottom: "10px",
            }}
          >
            <Col>
              <SelectComponent
                label="Select Resume Clinic Session"
                placeholder="Choose Cohort A or B"
                name={"eventDate"}
                id={"eventDate"}
                cName={"form-input p-0"}
                options={eventDates.map((date) => ({
                  value: `${date.formattedDate}`,
                  label: `${date.type === "second-saturday" ? "Cohort A" : "Cohort B"
                    } - ${date.formattedDate}`,
                  disabled: date.hasPassed,
                  className: date.hasPassed ? "past-date" : "",
                }))}
                hasLabel={true}
                control={control}
                multiSelect={false}
                rest={{ ...register("eventDate") }}
                errorText={errors?.eventDate?.message}
              />
            </Col>
          </Row>
          <Row
            style={{
              marginBottom: "10px",
            }}
          >
            <Col>
              <SelectComponent
                placeholder={"Role Interested In"}
                label={
                  "Please select job positions you are interested in. Make at least 3 selections"
                }
                name={"positionInterested"}
                id={"positionInterested"}
                cName={"form-input p-0"}
                options={jobRoleData}
                hasLabel={true}
                control={control}
                multiSelect={true}
                rest={{ ...register("positionInterested") }}
                errorText={errors?.positionInterested?.message}
              />
            </Col>
          </Row>
          <Row
            style={{
              marginBottom: "10px",
            }}
          >
            <Col>
              <DragAndDrop
                fileName={fileName}
                label={"Please attach you resume below"}
                required={false}
                name={"resume"}
                errorText={errors?.resume?.message}
                rest={{ ...register("resume") }}
                id={"resume"}
                handleDragDrop={handleFile}
                supportiveText={"File must be a PDF file"}
                multiple={false}
                control={control}
              />
            </Col>
          </Row>

          <Row
            style={{
              marginBottom: "10px",
            }}
          >
            <Col>
              <SelectComponent
                placeholder={"Select your gender"}
                options={genderData}
                cName={"form-input p-0"}
                hasLabel={true}
                errorText={errors?.gender?.message}
                name={"gender"}
                rest={{ ...register("gender") }}
                multiSelect={false}
                id={"gender"}
                label={"Gender"}
                control={control}
              />
            </Col>
          </Row>
          <Row
            style={{
              marginBottom: "10px",
            }}
          >
            <Col>
              <RadioComponent
                placeholder={""}
                label={"Educational Qualification"}
                name={"educationalQualification"}
                id={"educationalQualification"}
                cName={"form-input p-0"}
                options={educationalQualification}
                hasLabel={true}
                control={control}
                rest={{ ...register("educationalQualification") }}
                errorText={errors?.educationalQualification?.message}
                selectedValue={selectedEducationalQualification}
                handleChange={(value) =>
                  setSelectedEducationalQualification(value)
                }
              />
            </Col>
          </Row>
          <Row
            style={{
              marginBottom: "10px",
            }}
          >
            <Col>
              <RadioComponent
                placeholder={""}
                options={employmentStatus}
                cName={"form-input p-0"}
                hasLabel={true}
                errorText={errors?.employmentStatus?.message}
                name={"employmentStatus"}
                rest={{ ...register("employmentStatus") }}
                id={"employmentStatus"}
                label={"Employment Status"}
                control={control}
                selectedValue={selectedEmploymentStatus}
                handleChange={(value) => setSelectedEmploymentStatus(value)}
              />
            </Col>
          </Row>

          <Row
            style={{
              marginBottom: "10px",
            }}
          >
            <Col>
              <RadioComponent
                placeholder={""}
                label={"How actively are you seeking new opportunities?"}
                name={"jobSearchStatus"}
                id={"jobSearchStatus"}
                cName={"form-input p-0"}
                options={jobSearchStatusData}
                hasLabel={true}
                control={control}
                rest={{ ...register("jobSearchStatus") }}
                errorText={errors?.jobSearchStatus?.message}
                selectedValue={selectedJobSearchStatus}
                handleChange={(value) => setSelectedJobSearchStatus(value)}
              />
            </Col>
          </Row>

          <BtnWrapper>
            <ButtonComponent
              bgColor={primaryColor}
              text={status === "pending" ? "RSVPing ..." : "RSVP"}
              style={{
                minWidth: "100%",
                margin: "2.125rem auto 1rem auto",
              }}
              click={handleSubmit(onSubmit)}
              isLoading={status === "pending"}
            />
          </BtnWrapper>
        </Container>
      </form>
    </>
  );
};

export default ResumeClinicRsvpFormModal;

const RsvpHeadingWrapper = styled.div`
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: -3.5rem;
`;

const HeaderTitle = styled.h3`
  font-family: "Lato", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 37px;
  color: rgb(235, 129, 69);

  @media (min-width: 476px) {
    font-size: 30px;
  }
`;

const Text = styled.p`
  font-family: Lato;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 140%;
  color: #101010;
  text-align: center;
`;

const BtnWrapper = styled.div`
  margin-top: 40px;
`;
